import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["enabledCheckbox", "noticePeriodField", "noticePeriodInput", "disableWarning", "noticePeriodChangedWarning"];

  static values = {
    previouslyEnabled: Boolean,
    originalNoticePeriod: Number
  };

  connect() {
    this.refresh();
  }

  toggle() {
    this.refresh();
  }

  // Keep only integers within the 1..24 range.
  sanitize() {
    let value = this.noticePeriodInputTarget.value.replace(/[^0-9]/g, "");
    if (value !== "") {
      value = String(Math.min(parseInt(value, 10), 24));
    }
    this.noticePeriodInputTarget.value = value;
    this.refresh();
  }

  enforceMin() {
    const number = parseInt(this.noticePeriodInputTarget.value, 10);
    if (Number.isNaN(number) || number < 1) {
      this.noticePeriodInputTarget.value = "1";
    }
    this.refresh();
  }

  refresh() {
    const enabled = this.enabledCheckboxTarget.checked;

    this.noticePeriodFieldTarget.classList.toggle("hidden", !enabled);

    // Irreversible conversion warning: was enabled, now being disabled.
    const showDisableWarning = this.previouslyEnabledValue && !enabled;
    this.disableWarningTarget.classList.toggle("hidden", !showDisableWarning);

    // Notice period changed warning: still enabled, but the value differs from the saved one.
    const currentNoticePeriod = parseInt(this.noticePeriodInputTarget.value, 10);
    const showChangedWarning =
      this.previouslyEnabledValue &&
      enabled &&
      !Number.isNaN(currentNoticePeriod) &&
      currentNoticePeriod !== this.originalNoticePeriodValue;
    this.noticePeriodChangedWarningTarget.classList.toggle("hidden", !showChangedWarning);
  }
}
